import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlimContainerComponent } from './components/slim-container/slim-container.component';
import { CloseDialogComponent } from './components/_dialog/close-dialog/close-dialog.component';
import { GoBackButtonComponent } from './components/go-back-button/go-back-button.component';
import { PageHeaderActionsComponent } from './components/page-header-actions/page-header-actions.component';
import { PageTitleComponent } from './components/page-title/page-title.component';
import { GridMasterComponent } from './components/_grid/grid-master/grid-master.component';
import { PromptDialogComponent } from './components/_dialog/prompt-dialog/prompt-dialog.component';
import { DialogHeaderComponent } from './components/_dialog/dialog-header/dialog-header.component';
import { ButtonsWrapperComponent } from './components/buttons-wrapper/buttons-wrapper.component';
import { WhiteCardComponent } from './components/white-card/white-card.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { AgGridModule } from '@ag-grid-community/angular';
import { ModuleRegistry } from '@ag-grid-community/core';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { ExcelExportModule } from '@ag-grid-enterprise/excel-export';
import { StatusBarModule } from '@ag-grid-enterprise/status-bar';
import { MenuModule } from '@ag-grid-enterprise/menu';
import { SetFilterModule } from '@ag-grid-enterprise/set-filter';
import { RowGroupingModule } from '@ag-grid-enterprise/row-grouping';
import { IconOutlineComponent } from './components/icon-outline/icon-outline.component';
import { HomeBoxComponent } from './components/home-box/home-box.component';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DialogButtonsComponent } from './components/_dialog/dialog-buttons/dialog-buttons.component';
import { ProjectSelectionComponent } from './components/project-selection/project-selection.component';
import { ProjectSelectDialogComponent } from './components/project-selection/project-select-dialog/project-select-dialog.component';
import { MapComponent } from './components/map/map.component';
import { MatTabsModule } from '@angular/material/tabs';
import { SideBarModule } from '@ag-grid-enterprise/side-bar';
import { ColumnsToolPanelModule } from '@ag-grid-enterprise/column-tool-panel';
import { OnlynumberDirective } from './components/directives/onlynumber.directive';
import { MatTableModule } from '@angular/material/table';
import { FilesListComponent } from './components/file-uploader/files-list/files-list.component';
import { CaptionComponent } from './components/caption/caption.component';
import { MulticontrolComponent } from './components/multicontrol/multicontrol.component';
import { InfoContainerComponent } from './components/info-container/info-container.component';
import { MatBottomSheetModule } from "@angular/material/bottom-sheet";
import { BottomSheetAttributesComponent } from './components/bottom-sheet-attributes/bottom-sheet-attributes.component';
import { CaptionLabelBoxComponent } from './components/caption-label-box/caption-label-box.component';
import { AttributeItemComponent } from './components/attribute-item/attribute-item.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { SelectDialogComponent } from './components/_dialog/select-dialog/select-dialog.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DynamicControlComponent } from './components/dynamic-control/dynamic-control.component';
import { DynamicFormItemComponent } from './components/dynamic-form-item/dynamic-form-item.component';
import { DynamicFormComponent } from './components/dynamic-form/dynamic-form.component';
import { FormPreviewComponent } from './components/form-preview/form-preview.component';
import { ItemDescriptionComponent } from './components/item-description/item-description.component';
import { StatusPointComponent } from './components/status-point/status-point.component';
import { CustomFilterComponent } from './components/custom-filter/custom-filter.component';
import { InputDialogComponent } from './components/_dialog/input-dialog/input-dialog.component';
import { UnsavedChangesDialogComponent } from './components/_dialog/unsaved-changes-dialog/unsaved-changes-dialog.component';
import { FormHeadersComponent } from './components/form-headers/form-headers.component';
import { FailureListDialogComponent } from '../go/components/_dialog/failure-list-dialog/failure-list-dialog.component';
import { FailureItemComponent } from './components/failure-item/failure-item.component';
import { FailureRegisterDialogComponent } from "./components/failure-register-dialog/failure-register-dialog.component";
import {
  FailureFormV1Component
} from "./components/failure-register-dialog/versions/failure-form-v1/failure-form-v1.component";
import {
  FailureFormV2Component
} from "./components/failure-register-dialog/versions/failure-form-v2/failure-form-v2.component";
import {
  FailureFormV3Component
} from "./components/failure-register-dialog/versions/failure-form-v3/failure-form-v3.component";
import { SearchableSelectComponent } from './components/searchable-select/searchable-select.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { createTranslateLoader } from '../../translate-static.loader';

const components = [
  SlimContainerComponent,
  GoBackButtonComponent,
  PageHeaderActionsComponent,
  PageTitleComponent,
  GridMasterComponent,
  PromptDialogComponent,
  DialogHeaderComponent,
  ButtonsWrapperComponent,
  CloseDialogComponent,
  WhiteCardComponent,
  IconOutlineComponent,
  HomeBoxComponent,
  DialogButtonsComponent,
  ProjectSelectionComponent,
  ProjectSelectDialogComponent,
  MapComponent,
  OnlynumberDirective,
  FilesListComponent,
  CaptionComponent,
  MulticontrolComponent,
  InfoContainerComponent,
  BottomSheetAttributesComponent,
  CaptionLabelBoxComponent,
  DynamicControlComponent,
  DynamicFormItemComponent,
  DynamicFormComponent,
  FormPreviewComponent,
  ItemDescriptionComponent,
  StatusPointComponent,
  CustomFilterComponent,
  AttributeItemComponent,
  SelectDialogComponent,
  InputDialogComponent,
  UnsavedChangesDialogComponent,
  FormHeadersComponent,
  FailureItemComponent,
  FailureListDialogComponent,
  FailureRegisterDialogComponent,
  FailureFormV1Component,
  FailureFormV2Component,
  FailureFormV3Component,
  SearchableSelectComponent
];

const materialModules = [
  MatToolbarModule,
  MatButtonModule,
  MatIconModule,
  MatMenuModule,
  MatDialogModule,
  MatFormFieldModule,
  MatInputModule,
  MatAutocompleteModule,
  MatSelectModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatStepperModule,
  MatTooltipModule,
  MatListModule,
  MatRadioModule,
  MatDividerModule,
  MatButtonToggleModule,
  MatSnackBarModule,
  MatCheckboxModule,
  MatTableModule,
  MatTabsModule,
  MatBottomSheetModule,
  MatSlideToggleModule,
  MatExpansionModule,
  MatProgressBarModule,
  DragDropModule,
  NgxMatSelectSearchModule
];

ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  ExcelExportModule,
  StatusBarModule,
  MenuModule,
  SetFilterModule,
  RowGroupingModule,
  SideBarModule,
  ColumnsToolPanelModule
]);

@NgModule({
  declarations: [
    ...components
  ],
    imports: [
        CommonModule,
        ...materialModules,
        AgGridModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader
            },
            isolate: false
        }),
    ],
  exports: [
    ...components,
    ...materialModules,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
  ]
})
export class SharedModule { }
